import ReceiptProtocol from './ReceiptProtocol';

export default ReceiptProtocol;